var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-checkbox",class:{'is-checked': _vm.model}},[(_vm.model)?_c('Icon',{attrs:{"name":"check"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }